import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import dashboardService from '../../services/dashboard.service';

export const FORBIDDEN_PRESET = 'FORBIDDEN_PRESET';

export const fetchDashboard = createAsyncThunk(
  'dashboard/fetch',
  async (preset, { rejectWithValue }) => {
    try {
      return await dashboardService.getDashboard(preset);
    } catch (error) {
      const status = error?.response?.status;
      // 403 means the role changed since this page loaded: the caller refetches
      // without a preset, which lands on the role's current default.
      return rejectWithValue(
        status === 403 ? FORBIDDEN_PRESET
          : error?.response?.data?.detail || 'Could not load the dashboard.',
      );
    }
  },
);

const initialState = {
  preset: null,
  availablePresets: [],
  widgets: [],
  isLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Widgets are cleared so a previous preset's data is never shown
      // under the newly requested one.
      .addCase(fetchDashboard.pending, (state) => ({
        ...state, isLoading: true, error: null, widgets: [],
      }))
      .addCase(fetchDashboard.fulfilled, (state, action) => ({
        ...state,
        isLoading: false,
        preset: action.payload.preset,
        availablePresets: action.payload.available_presets || [],
        widgets: action.payload.widgets || [],
      }))
      .addCase(fetchDashboard.rejected, (state, action) => ({
        ...state,
        isLoading: false,
        widgets: [],
        error: action.payload || 'Could not load the dashboard.',
      }));
  },
});

export const selectWidgets = (state) => state.dashboard.widgets;
export const selectPreset = (state) => state.dashboard.preset;
export const selectAvailablePresets = (state) => state.dashboard.availablePresets;

export default dashboardSlice.reducer;
